import { useRepositoryMutation } from '@mews-commander/data-access';
import { lt, showSuccessAlert } from '@mews/framework';
import { useEnterpriseNavigate } from '@mews-commander/ui';

export const useCityLedgerExportMutation = (enterpriseId: string) => {
    const navigate = useEnterpriseNavigate();

    return useRepositoryMutation('cityLedger', 'export', {
        onSuccess: () => {
            showSuccessAlert({
                description: lt('CityLedgerExportSuccessful'),
                action: {
                    text: lt('CityLedgerExportDetailsRedirect'),
                    onClick: () => {
                        void navigate({
                            to: 'Export/Index',
                            search: { OwnerId: enterpriseId },
                            replace: true,
                        });
                    },
                },
            });
        },
    });
};
